import {
  createSummaryCardsConfig,
  createDataGridConfig,
} from '../email-pulse-config-defaults';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';

/**
 * Configuration for Gift Cards tab summary cards
 */
export const giftCardsSummaryCardsConfig = createSummaryCardsConfig(
  'giftCardsSummary',
  'GiftCardsSummaryCards',
);

/**
 * Configuration for Gift Cards tab data grid
 */
const giftCardsGrid = createDataGridConfig(
  'emailTypeDisplay',
  EMAIL_PULSE_DEFINITIONS.emailTypeDisplay,
);
export const getGiftCardsDataGridColumns = giftCardsGrid.getColumns;
export const giftCardsColumnVisibilityModel =
  giftCardsGrid.columnVisibilityModel;
